import { FIND_ASSIGNABLE_PRODUCT_ROUTINES } from '@gripp/shared-logic';
import { InfiniteDataGrid } from '@gripp/shared-ui';
import { ColumnDef } from '@tanstack/react-table';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useRoutineColumns } from '../../new-routines/components/useRoutineColumns';

export type ProductRoutinesAssignListProps = {
  workspaceId: string;
  productId: string;
  maxHeight?: number;
  keyword?: string;
  assignments: string[];
  updateAssignments: (assignments: string[]) => void;
};

export const ProductRoutinesAssignList = ({
  workspaceId,
  productId,
  maxHeight,
  keyword,
  assignments,
  updateAssignments,
}: ProductRoutinesAssignListProps) => {
  const { t } = useTranslation();
  const [filter, setFilter] = useState<any>(() => {
    if (assignments && workspaceId) {
      return { keyword, productId, assignments, workspaceId };
    }
    return undefined;
  });
  const columns = useRoutineColumns() as ColumnDef<any, any>[];

  useEffect(() => {
    setFilter({ keyword, productId, assignments, workspaceId });
  }, [keyword, productId, workspaceId]);

  if (!filter) return null;

  return (
    <InfiniteDataGrid
      modelName="routine"
      hideResultsLabel={true}
      query={FIND_ASSIGNABLE_PRODUCT_ROUTINES}
      filter={filter}
      pageSize={100}
      columns={columns}
      listMaxHeight={maxHeight as number}
      containerStyle={{ height: maxHeight }}
      paddingBottom={0}
      textEmpty={t('routines.textEmpty')}
      dataPrefix="product.findAssignableRoutinesForProduct"
      updateRowsSelected={(rows) => updateAssignments(rows)}
      isRowSelected={(row) => assignments.includes(row.id)}
      enableScrollRefresh={true}
      showScrollIndicator={true}
    />
  );
};
